import React, { useState, useEffect, PureComponent } from "react";
import "./css/SCPChart.css";
import { FaChartPie } from "react-icons/fa";
import { Tooltip, Legend, PieChart, Pie } from "recharts";
import { Styles, color } from "./SCPChartHelpers";
import { PieCustomTooltip } from "./CustomToolTip";
const RADIAN = Math.PI / 180;
const RenderLegend = (props) => {
  const { payload } = props;
  const dataKey = payload[0].payload.tooltipPayload[0].dataKey;
  //alert(JSON.stringify(payload[0]));

  return (
    <ul className="AxisLabels">
      <FaChartPie color={payload[0].color} /> {dataKey}
    </ul>
  );
};

const Renderlabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
  payload,
}) => {
  const labelName = Object.values(payload.payload)[0];
  //alert(JSON.stringify(Object.values(payload.payload)[0]));
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  //alert(Object.values({ percent }));
  if (Object.values({ percent }) > 0.2) {
    return (
      <text
        className="PieLabels"
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
      >
        {labelName} {": "}
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  }
};

const SCPPieChart = ({ jsonData, title }) => {
  const [inputData, setInputData] = useState([]);

  function sumKeyValues(jsonArray, key) {
    return jsonArray.reduce((sum, obj) => sum + (obj[key] || 0), 0);
  }
  const getPieChart = () => {
    const keysArr = Object.keys(jsonData[0]).slice(1);
    const valuesArr = Object.values(jsonData[0]).slice(1);
    const pieArr = [];
    //const name = Object.values(jsonData)[0];

    keysArr.forEach((item, index) => {
      //alert(typeof valuesArr[index])
      if (typeof valuesArr[index] != "string") {
        const totalValue = sumKeyValues(jsonData, item);
        pieArr.push(
          <td>
            <PieChart width={450} height={450}>
              <Pie
                data={jsonData}
                dataKey={item}
                cx="50%"
                cy="50%"
                innerRadius={80}
                outerRadius={150}
                strokeWidth={1}
                stroke="#282828"
                fill={color[index]}
                fillOpacity={0.4}
                label={Renderlabel}
                labelLine={false}
              ></Pie>
              <text
                className="PieCenterLabel"
                x={220}
                y={220}
                textAnchor="middle"
                dominantBaseline="middle"
              >
                {"Total: "}
                {totalValue}
              </text>
              <Tooltip
                cursor={false}
                content={<PieCustomTooltip active={false} payload={[]} />}
              />
              <Legend content={RenderLegend} />
            </PieChart>
          </td>
        );
      }
    });
    return pieArr;
  };

  useEffect(() => {
    const jsonString = document.getElementById("inputData").textContent;
    if (jsonString) {
      const values = new Set();
      jsonData.forEach((item) => {
        values.add(item);
      });
      setInputData(Array.from(values));
      setInputData(jsonData);
    }
  }, []);

  return (
    <>
      <div className="chartTitle">{title}</div>
      <table>
        <tr>{getPieChart()}</tr>
      </table>
    </>
  );
};

export default SCPPieChart;
